import React from 'react';
import { PopupDialog } from 'swag-client-common/components/info/popup-dialog';
import { Button, ButtonType, ButtonTextTransform, ButtonSize, ButtonFontSize } from 'swag-client-common/components/ui/button/button';
import classes from './sample-and-regular-products-popup.scss';
const popupClasses = {
  paper: classes.popupPaper,
  container: classes.popup
};
const SampleAndRegularProductsPopup = ({
  open,
  onClose,
  text
}) => /*#__PURE__*/React.createElement(PopupDialog, {
  open: open,
  onClose: onClose,
  title: "Hey, you need to make a change to continue!",
  classes: popupClasses,
  titleHeader: classes.title,
  contentClass: classes.content
}, /*#__PURE__*/React.createElement("p", {
  className: classes.text
}, text), /*#__PURE__*/React.createElement(Button, {
  className: classes.closeButton,
  type: ButtonType.primary,
  fontSize: ButtonFontSize.small,
  size: ButtonSize.large,
  textTransform: ButtonTextTransform.none,
  onClick: onClose
}, "Close"));
export default SampleAndRegularProductsPopup;